import ModelAbstract from './ModelAbstract';

class Group extends ModelAbstract {
    constructor({
        id = null,
        name = '',
        description = '',
        slug = '',
        visibility = 'public',
        joinType = 'open',
        memberCount = 0,
        followerCount = 0,
        viewCount = 0,
        currentAvatar = '',
        currentBanner = '',
        isFollowed = false,
        isFollowing = false,
        isMember = false,
        isPending = false,
        isInvited = false,
        isOwner = false,
        memberRole = null,
        owner = null,
        createdAt = null,
        updatedAt = null,
    } = {}) {
        super({ id, createdAt, updatedAt });
        this.name = name;
        this.description = description;
        this.slug = slug;
        this.visibility = visibility;
        this.joinType = joinType;
        this.memberCount = memberCount;
        this.followerCount = followerCount;
        this.viewCount = viewCount;
        this.currentAvatar = currentAvatar;
        this.currentBanner = currentBanner;
        this.isFollowed = isFollowed;
        this.isFollowing = isFollowing;
        this.isMember = isMember;
        this.isPending = isPending;
        this.isInvited = isInvited;
        this.isOwner = isOwner;
        this.memberRole = memberRole;
        this.owner = owner;
    }

    /**
     * Factory method to create a Group instance from API response
     * @param {Object} data - Raw group data from API
     * @returns {Group} - Instantiated Group object
     */
    static fromAPI(data) {
        if (!data) return null;
        
        return new Group({
            id: data.id,
            name: data.name,
            description: data.description,
            slug: data.slug,
            visibility: data.visibility,
            joinType: data.joinType,
            memberCount: data.memberCount,
            followerCount: data.followerCount,
            viewCount: data.viewCount,
            currentAvatar: data.currentAvatar,
            currentBanner: data.currentBanner,
            isFollowed: data.isFollowed,
            isFollowing: data.isFollowed ?? data.isFollowing,
            isMember: data.isMember,
            isPending: data.isPending,
            isInvited: data.isInvited,
            isOwner: data.isOwner,
            memberRole: data.memberRole,
            owner: data.owner,
            createdAt: data.createdAt,
            updatedAt: data.updatedAt,
        });
    }

    /**
     * Convert to plain object for JSON serialization
     */
    toJSON() {
        return {
            ...super.toJSON(),
            name: this.name,
            description: this.description,
            slug: this.slug,
            visibility: this.visibility,
            joinType: this.joinType,
            memberCount: this.memberCount,
            followerCount: this.followerCount,
            viewCount: this.viewCount,
            currentAvatar: this.currentAvatar,
            currentBanner: this.currentBanner,
            isFollowed: this.isFollowed,
            isMember: this.isMember,
            isPending: this.isPending,
            isOwner: this.isOwner,
            owner: this.owner,
        };
    }

    /**
     * Get visibility display text
     * @returns {string}
     */
    getVisibilityText() {
        switch (this.visibility) {
            case 'public':
                return 'Public';
            case 'private':
                return 'Private';
            case 'secret':
                return 'Secret';
            default:
                return 'Unknown';
        }
    }

    /**
     * Get join type display text
     * @returns {string}
     */
    getJoinTypeText() {
        switch (this.joinType) {
            case 'open':
                return 'Open';
            case 'approval':
                return 'Approval Required';
            case 'invite_only':
                return 'Invite Only';
            default:
                return 'Unknown';
        }
    }
}

export default Group;
export { Group };